export default __webpack_public_path__ + "static/media/default-banner.a9b6b05e.webp";